
export interface ContactEmail {
    id: number;
    email: string;
}

export interface ContactPhoneNumber {
    id: number;
    country_code: number;
    phone_number: string;
    phone_full: string;
}

export interface ContactTag {
    id?: number;
    name?: string;
    code?: string;
}

export interface ContactDeviceMap {
    id?: number;
    device_id?: string;
    device_name?: string;
    last_seen?: string;
}

export interface MinorEligibility {
    eligible: boolean;
    reason?: string;
    consent_signed?: boolean;
    agreement_variant?: 'standard' | 'bekiares';
}

export interface Contact {
    id: number;
    name: string;
    tags: ContactTag[] | string;
    trusted_person_id: number | null;
    emails: ContactEmail[];
    phone_numbers: ContactPhoneNumber[];
    blocked: boolean;
    public_key: string | null;
    risk: string | null;
    licensed: boolean | null;
    license?: string;
    access: boolean;
    is_minor: boolean;
    device_maps: ContactDeviceMap[];
    // Additional fields for family protection view
    exposures_count?: number;
    removals_count?: number;
    removals_count_30_days_ago?: number;
    in_progress_count?: number;
    in_progress_count_30_days_ago?: number;
    last_scan?: string | null;
    is_self?: boolean;
}

export interface ContactSelect {
    id: number;
    name: string;
    type: ContactType;
}

export enum ContactType {
    PERSON = 'person',
    CONTACT = 'contact'
}
